export const en = {
    manager: 'Manager',
    'support-phone': 'Support service'
};
